export class MaterialDataOptionsDictionary{
    static ID_MATERIAL_PAPER=10;
    static ID_MATERIAL_PVC=22;
    static ID_PAPER_WEIGHT = 14;
    static ID_PLATE_PAPER_SIZE = 15;
    static ID_DRUM_PAPER_SIZE = 16;
    static ID_CUSTOM_PAPER_SIZE = 17;
    static ID_PAPER_PRODUCT_SIZE = 19;
    static ID_PAPER_CUT_SIZE = 20;
    static ID_PAPER_DIGIT_CUT_SIZE = 30; 
    
    static ID_PVC_THICKNESS = 23;
    static ID_PLATE_PVC_SIZE = 25;
    static ID_DRUM_PVC_SIZE = 26;
    static ID_CUSTOM_PVC_SIZE = 27;
    static ID_PVC_CUT_SIZE = 28;

    static ENABLE_All=0;
    static DISABLE_ALL=1;
    static ENABLE=2;
    static DISABLE=3;
}
